import request from '../config/http';
import { ApiResponseGetVacancies } from '../models/Vacancy/ApiResponseGetVacancies';
import { IVacancyDto } from '../models/Vacancy/IVacancyDto';

const basicUrl = '/api/v1/secure/favorite-vacancy';

const getAllVacancyFavorite = (): Promise<ApiResponseGetVacancies<Array<IVacancyDto>>> =>
    request.get(basicUrl);

const updateVacancyFavorite = (params?: Record<string, unknown>) =>
    request.put(basicUrl + '/update', {}, { params });

export const vacancyFavoriteService = {
    getAllVacancyFavorite,
    updateVacancyFavorite,
};
